export default `
    <div id="#= data.id #" class=" progress progress-striped active loading-bar #= data.classes # #=data.bsc||""#">
        <span class="loading-bar-message # if (data.bindValue) { # bind-label # } #" # if (data.bindValue) { # data-bind="text: #= data.bindValue #" # } #>
            #= data.message || "" #
        </span>
        <div class="progress-bar"  style="width: #= data.startPercent #">
        </div>
    </div>
`;
